import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogActions } from "@material-ui/core";
import { Tabs, Tab } from "@material-ui/core";
import { pDialogMoveYourSkeleton } from "../../utils/parameters";
import Paper from "@mui/material/Paper";
import DialogTitle from '@mui/material/DialogTitle';
import DialogInfo from "./DialogInfo";
import DialogRanking from "./DialogRanking";
// import { Button } from '@mui/material';
import "../../styles/devices/mob_VersusMachine.css";
import Button from '@mui/joy/Button';
import { useTranslation } from "react-i18next";

export function MoveYourSkeletonDialog(props) {
  const { openDialog, setOpenDialog, server_report_activity, user_vid_original, user_vid_keypoints, user_vid_overlay, returnMenuMoveYourSkeleton, returnRecorderMoveYourSkeleton, returnNextMoveYourSkeleton} = props;
  const { t } = useTranslation("global")

  const [tabValue, setTabValue] = useState(pDialogMoveYourSkeleton.infoTab);
  const [ showOnlyRanking, setShowOnlyRanking ] = useState(false);

  /* Update first time */
  useEffect(() => {

    console.log("🚀 ~ file: MoveYourSkeletonDialog.js:27 ~ MoveYourSkeletonDialog ~ server_report_activity:", server_report_activity)

    setTabValue(pDialogMoveYourSkeleton.infoTab)
    if (server_report_activity['actual_score'] === -1) {    // Show only ranking
      setShowOnlyRanking(true)
    }else{
      setShowOnlyRanking(false)
    }
  }, [server_report_activity]);

  /* Close dialog */
  function handleClickClose() {
    setOpenDialog(false);
    setTabValue(pDialogMoveYourSkeleton.infoTab);
    returnMenuMoveYourSkeleton();
  }

  function handleClickRepeat() {
    setOpenDialog(false);
    setTabValue(pDialogMoveYourSkeleton.infoTab);
    returnRecorderMoveYourSkeleton();
  }

  function handleClickNext() {
    setOpenDialog(false);
    setTabValue(pDialogMoveYourSkeleton.infoTab);
    returnNextMoveYourSkeleton();
  }

  return (
    <Dialog open={openDialog} onClose={handleClickClose} maxWidth="md">
          {showOnlyRanking === false ? 
          <>
            <Paper square className="sig_SignModal_TabsPaper">
              <Tabs
                className="sig_SignModal_Tabs"
                value={tabValue}
                onChange={(event, newValue) => {
                  console.log('newValue', newValue)
                  setTabValue(newValue);
                }}
                indicatorColor="primary"
                textColor="primary"
                centered
              >
                <Tab className="sig_SignModal_Tab sig_VSResults_Tab" label={t("sMoveYourSkeleton.infoTab")} />
                <Tab className="sig_SignModal_Tab sig_VSResults_Tab" label={t("sMoveYourSkeleton.rankingTab")} />
              </Tabs>
            </Paper>

            <DialogContent className="sig_SignModal_DialogContent" style={{maxWidth: '450px'}}>

              {tabValue === pDialogMoveYourSkeleton.infoTab ? <DialogInfo server_report_activity={server_report_activity} user_vid_original={user_vid_original} user_vid_keypoints={user_vid_keypoints} user_vid_overlay={user_vid_overlay} /> : <></>}
              {tabValue === pDialogMoveYourSkeleton.rankingTab ? <DialogRanking server_report_activity={server_report_activity}/> : <></>}
            
            </DialogContent>

            <DialogActions>
              <div style={{ display: 'flex', justifyContent: 'space-between', margin: 'auto', width: '95%' }}>
                {/* <div style={{ width: '30%' }}>
                  <Button variant="soft" sx={{ border: 1 }} onClick={handleClickRepeat} style={{ height: '50px',  width: '100%', padding: '10px', margin: '5px'}}>
                    REPETIR GRABACIÓN
                  </Button>
                </div> */}
                <div style={{ width: '30%' }}>
                  <Button variant="soft" onClick={handleClickRepeat} style={{ height: '60px', width: '100%', padding: '5px', margin: '5px', lineHeight: '20px' }}>
                    REPETIR GRABACIÓN
                  </Button>
                </div>
                <div style={{ width: '30%' }}>
                  <Button onClick={handleClickNext} style={{ height: '60px', width: '100%', padding: '10px', margin: '5px', lineHeight: '20px' }}>
                    SIGUIENTE VÍDEO
                  </Button>
                </div>
                <div style={{ width: '30%' }}>
                  <Button variant="soft" onClick={handleClickClose} style={{ height: '60px', width: '100%', padding: '5px', margin: '5px', lineHeight: '20px' }}>
                    SALIR
                  </Button>
                </div>
              </div>
            </DialogActions>

          </> 
          : 
          <>
            <DialogTitle className='sig_Drawer_SettingsModal_Title' > {t("sMoveYourSkeleton.rankingTab")} </DialogTitle>

            <DialogContent className="sig_SignModal_DialogContent" style={{maxWidth: '450px'}}>

              <DialogRanking server_report_activity={server_report_activity}/>

            </DialogContent>

            <DialogActions className="sig_FormDialog_Button">
              <div>
                <Button variant="soft" onClick={handleClickClose}> {t("strButton.btn_exit").toUpperCase()} </Button>
              </div>
            </DialogActions>

          </>
          }
    </Dialog>
  );
}

